export default "__VITE_ASSET__BpHQBsw7__"